"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectors = exports.sagas = exports.createRootReducer = exports.actions = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _connectedReactRouter = require("connected-react-router");
var _reduxPersist = require("redux-persist");
var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));
var _sagas = require("./Amenity/sagas");
var _sagas2 = require("./AuthorizedGuest/sagas");
var _sagas3 = require("./Auth/sagas");
var _sagas4 = require("./CheckinPass/sagas");
var _sagas5 = require("./Class/sagas");
var _sagas6 = require("./Community/sagas");
var _sagas7 = require("./Condominium/sagas");
var _sagas8 = require("./Contractor/sagas");
var _sagas9 = require("./Event/sagas");
var _sagas10 = require("./GateCamera/sagas");
var _sagas11 = require("./LookOutList/sagas");
var _sagas12 = require("./Packages/sagas");
var _sagas13 = require("./Pets/sagas");
var _sagas14 = require("./Report/sagas");
var _sagas15 = require("./Resource/sagas");
var _sagas16 = require("./Settings/sagas");
var _sagas17 = require("./StaffNotes/sagas");
var _sagas18 = require("./TempFiles/sagas");
var _sagas19 = require("./Unit/sagas");
var _sagas20 = require("./User/sagas");
var _sagas21 = require("./Valet/sagas");
var _sagas22 = require("./Vehicles/sagas");
var _sagas23 = require("./PushNotification/sagas");
var _reducer = _interopRequireDefault(require("./Amenity/reducer"));
var _reducer2 = _interopRequireDefault(require("./AuthorizedGuest/reducer"));
var _reducer3 = _interopRequireDefault(require("./Auth/reducer"));
var _reducer4 = _interopRequireDefault(require("./CheckinPass/reducer"));
var _reducer5 = _interopRequireDefault(require("./Class/reducer"));
var _reducer6 = _interopRequireDefault(require("./Community/reducer"));
var _reducer7 = _interopRequireDefault(require("./Condominium/reducer"));
var _reducer8 = _interopRequireDefault(require("./Contractor/reducer"));
var _reducer9 = _interopRequireDefault(require("./Event/reducer"));
var _reducer10 = _interopRequireDefault(require("./GateCamera/reducer"));
var _reducer11 = _interopRequireDefault(require("./LookOutList/reducer"));
var _reducer12 = _interopRequireDefault(require("./Notification/reducer"));
var _reducer13 = _interopRequireDefault(require("./Packages/reducer"));
var _reducer14 = _interopRequireDefault(require("./Pets/reducer"));
var _reducer15 = _interopRequireDefault(require("./Report/reducer"));
var _reducer16 = _interopRequireDefault(require("./Resource/reducer"));
var _reducer17 = _interopRequireDefault(require("./Settings/reducer"));
var _reducer18 = _interopRequireDefault(require("./StaffNotes/reducer"));
var _reducer19 = _interopRequireDefault(require("./TempFiles/reducer"));
var _reducer20 = _interopRequireDefault(require("./Unit/reducer"));
var _reducer21 = _interopRequireDefault(require("./User/reducer"));
var _reducer22 = _interopRequireDefault(require("./Valet/reducer"));
var _reducer23 = _interopRequireDefault(require("./Vehicles/reducer"));
var _reducer24 = _interopRequireDefault(require("./PushNotification/reducer"));
var reportActions = _interopRequireWildcard(require("./Report/actions"));
var authGuestActions = _interopRequireWildcard(require("./AuthorizedGuest/actions"));
var communityActions = _interopRequireWildcard(require("./Community/actions"));
var condominiumActions = _interopRequireWildcard(require("./Condominium/actions"));
var contractorsActions = _interopRequireWildcard(require("./Contractor/actions"));
var eventActions = _interopRequireWildcard(require("./Event/actions"));
var pushNotificationActions = _interopRequireWildcard(require("./PushNotification/actions"));
var unitActions = _interopRequireWildcard(require("./Unit/actions"));
var userActions = _interopRequireWildcard(require("./User/actions"));
var amenitySelectors = _interopRequireWildcard(require("./Amenity/selectors"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // SAGAS
// REDUCERS
//ACTIONS
// SELECTORS
var createRootReducer = exports.createRootReducer = function createRootReducer(history) {
  return (0, _reduxPersist.persistCombineReducers)({
    key: 'root',
    storage: _storage["default"]
  }, {
    amenity: _reducer["default"],
    auth: _reducer3["default"],
    authorizedGuest: _reducer2["default"],
    checkinPass: _reducer4["default"],
    classes: _reducer5["default"],
    community: _reducer6["default"],
    condominium: _reducer7["default"],
    contractor: _reducer8["default"],
    event: _reducer9["default"],
    gateCamera: _reducer10["default"],
    lol: _reducer11["default"],
    notification: _reducer12["default"],
    packages: _reducer13["default"],
    pets: _reducer14["default"],
    report: _reducer15["default"],
    resource: _reducer16["default"],
    router: (0, _connectedReactRouter.connectRouter)(history),
    staffNotes: _reducer18["default"],
    settings: _reducer17["default"],
    tempFiles: _reducer19["default"],
    unit: _reducer20["default"],
    user: _reducer21["default"],
    valet: _reducer22["default"],
    vehicles: _reducer23["default"],
    pushNotification: _reducer24["default"]
  });
};
var sagas = exports.sagas = /*#__PURE__*/_regenerator["default"].mark(function rootSaga() {
  return _regenerator["default"].wrap(function rootSaga$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _context.next = 2;
        return (0, _effects.all)([(0, _sagas.amenityWatcher)(), (0, _sagas3.authWatcher)(), (0, _sagas2.authorizedGuestWatcher)(), (0, _sagas4.checkinPassWatcher)(), (0, _sagas5.classWatcher)(), (0, _sagas6.communityWatcher)(), (0, _sagas7.condominiumWatcher)(), (0, _sagas8.contractorsWatcher)(), (0, _sagas9.eventsWatcher)(), (0, _sagas10.gateCameraWatcher)(), (0, _sagas11.lolWatcher)(), (0, _sagas12.packagesWatcher)(), (0, _sagas13.petsWatcher)(), (0, _sagas14.reportWatcher)(), (0, _sagas15.resourcesWatcher)(), (0, _sagas16.settingsWatcher)(), (0, _sagas17.staffNotesWatcher)(), (0, _sagas18.tempFilesWatcher)(), (0, _sagas19.unitsWatcher)(), (0, _sagas20.userWatcher)(), (0, _sagas21.valetWatcher)(), (0, _sagas22.vehiclesWatcher)(), (0, _sagas23.pushNotificationWatcher)()]);
      case 2:
        return _context.abrupt("return", _context.sent);
      case 3:
      case "end":
        return _context.stop();
    }
  }, rootSaga);
});
var selectors = exports.selectors = _objectSpread({}, amenitySelectors);
var actions = exports.actions = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, reportActions), authGuestActions), communityActions), condominiumActions), contractorsActions), eventActions), pushNotificationActions), unitActions), userActions);